package com.vidaensupalabra.vsp

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

import com.vidaensupalabra.vsp.navigation.Router
import com.vidaensupalabra.vsp.navigation.Screen
import com.vidaensupalabra.vsp.ui.theme.VspBase
import com.vidaensupalabra.vsp.ui.theme.VspMarco
import com.vidaensupalabra.vsp.ui.theme.White
import com.vidaensupalabra.vsp.datos.ArdeRepository
import com.vidaensupalabra.vsp.ventanas.*

private data class NavItemSpec(val title: String, val icon: String, val screen: Screen)

// Reemplazamos los iconos vectoriales/imágenes por Emojis nativos para máxima compatibilidad web
private val BOTTOM_NAV_ITEMS = listOf(
    NavItemSpec("Inicio", "⛪", Screen.Home),
    NavItemSpec("A.R.D.E", "📖", Screen.Arde),
    NavItemSpec("Canciones", "🎵", Screen.Musica),
    NavItemSpec("Info", "ℹ️", Screen.Information),
    NavItemSpec("Más", "☰", Screen.Mas)
)

@Composable
fun App() {
    // Contenedor Maestro: Ocupa toda la pantalla (Scaffold equivalente)
    Div(attrs = {
        style {
            width(100.percent)
            height(100.vh)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            backgroundColor(VspBase)
            fontFamily("sans-serif")
            property("overflow", "hidden") // Evita el scroll en el body, lo manejamos en el contenido
        }
    }) {
        // Área de contenido dinámico (NavHost equivalente)
        Div(attrs = {
            style {
                flex(1)
                width(100.percent)
                property("overflow-y", "auto") // Permite hacer scroll en las pantallas
                paddingBottom(70.px) // Espacio reservado para el Bottom Navigation
            }
        }) {
            when (val current = Router.currentScreen) {
                is Screen.Home -> HomeScreen()
                is Screen.Arde -> ARDEScreen(
                    onNavigateToDetail = { y, m, d -> Router.navigateTo(Screen.Devocional(y, m, d)) }
                )
                is Screen.Musica -> MusicaScreen()
                is Screen.Information -> InformationScreen()
                is Screen.Mas -> MasScreen(
                    onNavigateToDonaciones = { Router.navigateTo(Screen.Donacion) },
                    onNavigateToMultimedia = { Router.navigateTo(Screen.Multimedia) },
                onNavigateToComunidad = { Router.navigateTo(Screen.Comunidad()) },
                onNavigateToPerfil = { Router.navigateTo(Screen.Perfil()) }
                )
            is Screen.Donacion -> DonacionScreen(onBack = { Router.goBack() })
            is Screen.Multimedia -> MultimediaScreen(onBack = { Router.goBack() })
        is Screen.Comunidad -> ComunidadScreen(initialPost = current.initialPost, initialPostId = current.initialPostId, onBack = { Router.goBack() })
        is Screen.Perfil -> PerfilScreen(
            targetUserId = current.userId,
            targetUserName = current.userName,
            targetUserPhoto = current.userPhoto,
            onBack = { Router.goBack() }
        )
                is Screen.Devocional -> {
                    val ardeItem = ArdeRepository.getArde(current.year, current.month, current.day)
                    DevocionalScreen(
                        arde = ardeItem,
                        onSave = { updatedArde -> ardeItem?.devocional = updatedArde.devocional },
                    onClose = { Router.goBack() }
                    )
                }
            }
        }

        // Menú de Navegación Inferior (BottomNavigationBar equivalente)
        BottomNavigationBar()
    }
}

@Composable
private fun BottomNavigationBar() {
    Div(attrs = {
        style {
            position(Position.Fixed)
            bottom(0.px)
            left(0.px)
            width(100.percent)
            height(70.px)
            backgroundColor(VspMarco)
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.SpaceAround)
            alignItems(AlignItems.Center)
            property("box-shadow", "0px -2px 10px rgba(0,0,0,0.3)")
            property("z-index", 1000)
            property("user-select", "none") // Bloquea selección en navegadores modernos
            property("-webkit-user-select", "none") // Bloquea selección en iOS/Safari
            property("-webkit-touch-callout", "none") // Bloquea la lupa y el menú contextual emergente en iOS/Android
            property("-webkit-tap-highlight-color", "transparent") // Elimina el parpadeo de selección azul en Android
        }
    }) {
        BOTTOM_NAV_ITEMS.forEach { item ->
            // Lógica para mantener iluminado el tab padre si estamos en una sub-pantalla
            val isSelected = when (item.screen) {
                Screen.Arde -> Router.currentScreen is Screen.Arde || Router.currentScreen is Screen.Devocional
                Screen.Mas -> Router.currentScreen is Screen.Mas || Router.currentScreen is Screen.Donacion || Router.currentScreen is Screen.Multimedia || Router.currentScreen is Screen.Comunidad || Router.currentScreen is Screen.Perfil
                else -> Router.currentScreen == item.screen
            }

            Div(attrs = {
                onClick { Router.navigateTo(item.screen) }
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    cursor("pointer")
                    padding(8.px)
                    flex(1)
                    color(if (isSelected) VspBase else White)
                }
            }) {
                Span(attrs = { style { fontSize(24.px); marginBottom(4.px); if (!isSelected) opacity(0.6) } }) { Text(item.icon) }
                Span(attrs = { style { fontSize(12.px); fontWeight(if (isSelected) "bold" else "normal"); if (!isSelected) opacity(0.8) } }) { Text(item.title) }
            }
        }
    }
}